import { LinkItem } from '@occc/ui-design-system';
import { AudienceBroadcastMessageStatus } from '@occc/graphql';

import { EDITABLE_CAMPAIGN_STATUSES } from './messaging-campaign-update.constants';

import { routeCreator } from '../../messaging-center.utils';
import {
  CAMPAIGN_LIST_PAGE_TITLE,
  PAGE_TITLE as BASE_PAGE_TITLE,
} from '../../messaging-center.constants';

export const getUpdateBreadcrumbLinks = ({
  campaignId,
  campaignName,
  pageTitle,
}: {
  campaignId: string;
  campaignName?: string;
  pageTitle?: string;
}): LinkItem[] => {
  return [
    { to: routeCreator.base(), label: BASE_PAGE_TITLE },
    { to: routeCreator.campaignsList(), label: CAMPAIGN_LIST_PAGE_TITLE },
    {
      to: routeCreator.campaignDetails(campaignId),
      label: campaignName || 'Loading...',
    },
    {
      key: pageTitle,
      label: pageTitle,
    },
  ];
};

export const getIsEditableByStatus = (
  status: AudienceBroadcastMessageStatus | undefined,
): boolean => {
  if (!status) return false;

  return EDITABLE_CAMPAIGN_STATUSES.includes(status);
};
